import { useMetaPixel } from '@/hooks/useMetaPixel';

/**
 * Component that tracks Meta Pixel PageView events on route changes
 * Should be placed inside BrowserRouter in App.tsx
 */
export const MetaPixelTracker = () => {
  useMetaPixel();
  return null;
};
